import { eventEmitter } from "@/utils/event-emitter.js";
import { setLS, getLS } from "@/utils/local-storage.js";

export function soundsChange() {
  eventEmitter.on("soundsChange", () => {
    const soundStatus = getLS("sound");
    soundStatus === "on" ? setLS("sound", "off") : setLS("sound", "on");
  });
}
